import { html, css } from 'lit';

import Table, {
  ELEMENTS as BASE_ELEMENTS,
} from '../../../packages/neb-lit-components/src/components/tables/neb-table';
import { parseDate } from '../../../packages/neb-utils/date-util';
import { SCHEDULE_PAYMENT_STATUS } from '../../../packages/neb-utils/enums';
import { centsToCurrency } from '../../../packages/neb-utils/formatters';
import { MODE } from '../../../packages/neb-utils/table';

export const ELEMENTS = {
  ...BASE_ELEMENTS,
  blankIcons: { selector: '[id^=icon-blank-]' },
};

export const EMPTY_MESSAGE =
  'There is no payment history for this subscription';

export const STATUS = Object.freeze({
  ...SCHEDULE_PAYMENT_STATUS,
  POSTED: 'Posted',
});

export const TABLE_CONFIG_SUBSCRIPTION_PAYMENTS = [
  {
    key: 'start',
    label: 'Date',
    flex: css`1 0 0`,
    formatter: v => parseDate(v).format('MM/DD/YYYY'),
  },
  {
    key: 'amount',
    label: 'Amount',
    flex: css`1 0 0`,
    formatter: v => centsToCurrency(v),
  },
  {
    key: 'status',
    label: 'Status',
    flex: css`1 0 0`,
    formatter: (v, item) => {
      if (item.manuallyPaid) {
        return 'Paid Manually';
      }
      return v || 'Scheduled';
    },
  },
  {
    key: 'type',
    label: 'Type',
    flex: css`1 0 0`,
    formatter: () => 'Automatic',
  },
];

export const TABLE_CONFIG_SUBSCRIPTION_CHARGES = [
  {
    key: 'date',
    label: 'Date',
    flex: css`1 0 0`,
    formatter: v => parseDate(v).format('MM/DD/YYYY'),
  },
  {
    key: 'amount',
    label: 'Amount',
    flex: css`1 0 0`,
    formatter: v => centsToCurrency(v),
  },
  {
    key: 'status',
    label: 'Status',
    flex: css`1 0 0`,
  },
  {
    key: 'type',
    label: 'Type',
    flex: css`1 0 0`,
    formatter: () => 'Manual',
  },
];

class NebTableSubscriptionPaymentHistory extends Table {
  initState() {
    super.initState();

    this.mode = MODE.DETAIL;
    this.emptyMessage = EMPTY_MESSAGE;
  }

  renderRow(item, index) {
    const clickable = [STATUS.POSTED, STATUS.PAID].includes(item.status);

    return html`
      <div
        id="row-${index}"
        class="row row-data"
        row="${index}"
        @click="${this.handlers.clickRow}"
      >
        <div class="content" ?clickable="${clickable}">
          ${this.__renderDataCells(item, index)}
          ${clickable
            ? this.renderModeCell(index)
            : this.__renderBlankIcon(index)}
        </div>
      </div>
    `;
  }

  __renderBlankIcon(index) {
    return html`
      <span id="icon-blank-${index}" class="cell cell-detail"></span>
    `;
  }
}

customElements.define(
  'neb-table-subscription-payment-history',
  NebTableSubscriptionPaymentHistory,
);
